// utils/formatTime.js

// 1) 시간 문자열 포맷 (예: "0900" -> "9:00 AM")
export const formatTime = (timeString) => {
    // 입력값이 문자열이 아니면 문자열로 변환
    if (typeof timeString !== 'string') {
        timeString = String(timeString);
    }

    if (!timeString) return "데이터 없음";

    const length = timeString.length;

    if (length <= 4) {
        const hours = parseInt(timeString.substring(0, 2), 10);
        const minutes = timeString.substring(2, 4);
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return `${formattedHours}:${minutes} ${period}`;
    }

    if (length >= 5) {
        const hours = parseInt(timeString.substring(0, 2), 10);
        const minutes = timeString.substring(2, 4);
        const seconds = length === 6 ? timeString.substring(4, 6) : "00";
        const period = hours >= 12 ? 'PM' : 'AM';
        const formattedHours = hours % 12 || 12;
        return length === 6
            ? `${formattedHours}:${minutes} ${seconds} ${period}`
            : `${formattedHours}:${minutes} ${period}`;
    }

    return "Err";
};

// 2) UTC → KST 변환
export const toKST = (dateStr) => {
    if (!dateStr) return null;
    const d = new Date(dateStr);
    if (Number.isNaN(d.getTime())) return null;

    const KST_OFFSET = 9 * 60 * 60 * 1000; // 9시간(ms)
    return new Date(d.getTime() + KST_OFFSET);
};

// 3) 상대 시간 포맷 (N분 전 / N시간 전 / N일 전 / YYYY.MM.DD)
export const formatRelativeTime = (dateStr) => {
    const d = toKST(dateStr);       // UTC + 9시간
    if (!d) return "";

    const now = new Date();
    const diffMs = now.getTime() - d.getTime();

    const MINUTE = 60 * 1000;
    const HOUR = 60 * MINUTE;
    const DAY = 24 * HOUR;

    // 1분 미만
    if (diffMs < MINUTE) return "지금";

    // 1 ~ 59분
    if (diffMs < HOUR) {
        const mins = Math.floor(diffMs / MINUTE) || 1;
        return `${mins}분 전`;
    }

    // 1 ~ 23시간
    if (diffMs < 24 * HOUR) {
        const hours = Math.floor(diffMs / HOUR);
        return `${hours}시간 전`;
    }

    // 1 ~ 30일
    if (diffMs < 31 * DAY) {
        const days = Math.floor(diffMs / DAY);
        return `${days}일 전`;
    }

    // 30일 초과 → YYYY.MM.DD
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    return `${year}.${month}.${day}`;
};

// 🔹 기본(default) export: 옛날 코드 호환용 (formatTime 함수)
export default formatTime;
